<template>
    <zen-message-modal :isOpen="isOpen" title="Remove segment?">
        Removing this segment is immediate. After the segment is removed, this
        context will no longer adhere to the targeting rules for the segment.
        <strong>This action is irreversible.</strong>
        <template v-slot:buttons>
            <zen-button variant="primary-danger" @click="$emit('confirm')">
                Remove
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RemoveContextSegmentModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
